/**
 * This is credit generator, we dont aim to be so narcissus but we deserve it
 */
try {

    let creators = [
        "JAVIER FEDERICO GONZALEZ HERNANDEZ",
        "DIEGO JOSHUA MARTINEZ PINEDA",
        "UVERUT ROGELIO PENNEY VAZQUEZ",
        "MIGUEL ANGEL COX BELTRAN",
        "JUAN RAMON IGNACIO VALDEZ"
    ];
    let messages = [
        "Bienvenido a VTEmployees",
        "\nMade with ❤ by %cVTSoftwares"
    ];
    let colors = [
        "#4baea0",
        "#b6e6bd",
        "#f0c9c9"
    ];
    let getStyle = (color) => "color: " + color + "; font-size: 24px; font-family: 'Segoe UI Emoji', 'Segoe UI Symbol'";
    let styles = colors.map(color => getStyle(color));

    console.log('%c' + messages.join('%c'), ...styles);
}
catch (e) {
        /*  If this fails, just ignore, dont panic (calma, calma, que no panda el cúnico)  */
}





